// Used in StudyData form actions
// TODO: rename to something like RevertVersionModal
import React from 'react';

// components
import Modal from '../Modal/Modal';
import { FormButtons } from 'components-design-system'

import './ConfirmModal.scss'

const ConfirmModal = ({
  openModal,
  setOpenModal,
  header,
  content,
  onAction,
  actionLabel,
}) => {

  const handleAction = () => {
    setOpenModal(false);
    onAction();
  };

  return (
    <Modal
      title={header}
      open={openModal}
      onCancel={() => setOpenModal(false)}
      footer={[]}
      hideImage={true}>
      {content}
      <div className="confirm-modal-action-container">
        <FormButtons
          size="large"
          cancelText="Cancel"
          onCancel={() => setOpenModal(false)}
          okText={actionLabel || 'Continue'}
          onOk={handleAction}
        />
      </div>
    </Modal>
  );
};

export default ConfirmModal;